// Pure grant predicates, kept apart from authStore so modules (and test
// mocks of authStore) can use them without the store's side effects.
import type { AuthUser } from './authStore';

export type GrantsStatus = 'unknown' | 'ready' | 'error';

/** Only `ready` grants authorize an action; hooks/useGrantSlot.ts keeps a
 *  restored grant's layout slot (disabled) while it is not yet confirmed. */
export function selectGrantsStatus(s: { user: AuthUser | null }): GrantsStatus {
  if (!s.user) return 'unknown';
  return s.user.grantsPending ?? 'ready';
}

export type GrantKey = 'botAccess' | 'oscarAccess' | 'oneClickAccess' | 'lt2Access' | 'attackAccess';

/** A grant authorizes only once this session confirmed it; a restored or
 *  failed-to-refresh grant reads as not granted. */
export function hasConfirmedGrant(user: AuthUser | null | undefined, key: GrantKey): boolean {
  return user?.[key] === true && !user.grantsPending;
}

